<template>
    <div>
        <div class="header-return">
            <el-row :gutter="20">
                <el-col :span="2">
                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                </el-col>
                <el-col :span="2" :offset="20">
                    <!--<el-button type="primary" @click="addCrowdProductConfig()" class="header-btn">新建</el-button>-->
                </el-col>
            </el-row>
        </div>
        <el-row :gutter="20">
            <el-table :data="crowdOrderList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading"
                     >
                <el-table-column prop="ACTIVE_NAME" label="众筹活动名称" width="250"></el-table-column>
                <el-table-column prop="CREATE_TIME" label="日期" width="250"></el-table-column>
                <el-table-column prop="orderNum" label="订单数" ></el-table-column>
            </el-table>
            <div class="pagination-wrap" >
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline.recordsTotal">
                </el-pagination>
            </div>
        </el-row>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        getCrowdOrderList
    } from '../../api/api';
    export default {
        data() {
            return {
                loading: true,
                crowdOrderList:[],
                formInline: {
                    platformId: 1,
                    currentPage: 1,
                    pageSize: 10,
                    date:'',
                    orderClass:6,
                    recordsTotal: 0
                }
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.getOrderList4Crowd();
        },
        methods: {
            getOrderList4Crowd(){
                this.loading = true;
                getCrowdOrderList(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.crowdOrderList = res.data.value;
                        this.formInline.recordsTotal = res.data.value.total;
                    } else {
                        this.$message({
                            showClose: true,
                            message: '系统错误，请联系管理员',
                            type: 'error'
                        });
                    }
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getOrderList4Crowd();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getOrderList4Crowd();
            },
            returnHistory(){
                window.history.back()
            }
        }
    }
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/views/crowd/crowdOrder.vue